'use strict';

var _objectSpread = require("/Users/aidev/Downloads/baddeezphotos/streamlify-web3-video-streaming-app/Streamlify - v2.0/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function encodeEndpoint(url) {
  var href = String(url);

  if (href === 'undefined') {
    throw Error('endpoint is required');
  }

  return href[href.length - 1] === '/' ? href.slice(0, -1) : href;
}

function decodeRemoteService(json) {
  return _objectSpread({
    service: json.Service,
    endpoint: new URL(json.ApiEndpoint)
  }, json.Stat && {
    stat: decodeStat(json.Stat)
  });
}

function decodeStat(json) {
  switch (json.Status) {
    case 'valid':
      {
        var _json$PinCount = json.PinCount,
            Pinning = _json$PinCount.Pinning,
            Pinned = _json$PinCount.Pinned,
            Queued = _json$PinCount.Queued,
            Failed = _json$PinCount.Failed;
        return {
          status: 'valid',
          pinCount: {
            queued: Queued,
            pinning: Pinning,
            pinned: Pinned,
            failed: Failed
          }
        };
      }

    case 'invalid':
      {
        return {
          status: 'invalid'
        };
      }

    default:
      {
        return {
          status: json.Status
        };
      }
  }
}

exports.decodeRemoteService = decodeRemoteService;
exports.decodeStat = decodeStat;
exports.encodeEndpoint = encodeEndpoint;